module.exports = __webpack_public_path__ + "9459fe745578c05c2b0ce49d4ed16385.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_4_sq.mp3
 ** module id = 180
 ** module chunks = 0
 **/